import { BuildingType } from '../../../types';
import type { Grid } from '../../../types';
import { GRID_SIZE } from '../../../constants';

/** BFS connectivity from Core through Pipeline tiles */
export function calculateConnectivity(grid: Grid): Grid {
  const newGrid = grid.map((row) => row.map((tile) => ({ ...tile, isConnected: false })));
  const queue: { x: number; y: number }[] = [];
  const visited = new Set<string>();

  newGrid.forEach((row) =>
    row.forEach((tile) => {
      if (tile.buildingType === BuildingType.Core) {
        queue.push({ x: tile.x, y: tile.y });
        visited.add(`${tile.x},${tile.y}`);
        tile.isConnected = true;
      }
    })
  );

  const directions = [
    [0, 1],
    [0, -1],
    [1, 0],
    [-1, 0],
  ];

  while (queue.length > 0) {
    const { x, y } = queue.shift()!;

    for (const [dx, dy] of directions) {
      const nx = x + dx;
      const ny = y + dy;

      if (nx >= 0 && nx < GRID_SIZE && ny >= 0 && ny < GRID_SIZE) {
        const key = `${nx},${ny}`;
        if (!visited.has(key)) {
          const neighbor = newGrid[ny][nx];
          const me = newGrid[y][x];

          if (me.buildingType === BuildingType.Core || me.buildingType === BuildingType.Pipeline) {
            if (neighbor.buildingType === BuildingType.Pipeline) {
              neighbor.isConnected = true;
              visited.add(key);
              queue.push({ x: nx, y: ny });
            } else if (neighbor.buildingType !== BuildingType.None) {
              neighbor.isConnected = true;
              visited.add(key);
            }
          }
        }
      }
    }
  }
  return newGrid;
}